module.exports = __webpack_public_path__ + "img/down-fj3.5c26f17f.jpg";